export default "__VITE_ASSET__df5fcd27__"